import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime.js';
import localizedFormat from 'dayjs/plugin/localizedFormat.js';
import updateLocale from 'dayjs/plugin/updateLocale.js';
import calendar from 'dayjs/plugin/calendar.js';
import de from 'dayjs/locale/de.js';
import en from 'dayjs/locale/en-gb.js';
export function monthName(locale, millis, short) {
    var _a, _b;
    const mon = dayjs(millis).month();
    const lang = locale === 'en' ? en : de;
    if (short && lang.monthsShort) {
        return lang.monthsShort[mon];
    }
    else {
        return ((_b = (_a = lang === null || lang === void 0 ? void 0 : lang.months) === null || _a === void 0 ? void 0 : _a[mon]) !== null && _b !== void 0 ? _b : ' Jan Feb Mär Apr Mai Jun Jul Aug Sep Okt Nov Dez'.split(' ')[mon]);
    }
}
export function yearNum(millis, delta) {
    return (dayjs(millis).year() + (delta !== null && delta !== void 0 ? delta : 0)).toFixed(0);
}
export const nowMillis = () => {
    return Date.now();
};
export const startOf = (unitOfTime) => (millis) => {
    return dayjs(millis).startOf(unitOfTime).valueOf();
};
export const endOf = (unitOfTime) => (millis) => {
    return dayjs(millis).endOf(unitOfTime).valueOf();
};
export const formatTimestamp = (options) => (millis) => {
    const { format, locale } = Object.assign({ format: '', locale: 'en' }, options);
    return dayjs(millis).locale(locale).format(format);
};
export const fromNow = (options) => (millis) => {
    const { locale, granular } = Object.assign({ locale: 'en', granular: false }, options);
    if (granular) {
        return dayjs(millis).locale(locale).fromNow();
    }
    return dayjs(millis).locale(locale).calendar();
};
/* Side effects */
dayjs.extend(calendar);
dayjs.extend(relativeTime);
dayjs.extend(localizedFormat);
dayjs.extend(updateLocale);
dayjs.updateLocale('en', {
    calendar: {
        lastDay: '[Yesterday]',
        sameDay: '[Today]',
        nextDay: '[Tomorrow]',
        lastWeek: 'll',
        nextWeek: 'll',
        sameElse: 'll',
    },
});
dayjs.updateLocale('de', {
    calendar: {
        lastDay: '[Gestern]',
        sameDay: '[Heute]',
        nextDay: '[Morgen]',
        lastWeek: 'll',
        nextWeek: 'll',
        sameElse: 'll',
    },
});
//# sourceMappingURL=datetime.js.map